import { useApp } from "../context/AppContext";

const MODES = [
  { key: "light", label: "Light", icon: "☀️", desc: "Always light" },
  { key: "dark", label: "Dark", icon: "🌙", desc: "Always dark" },
  { key: "auto", label: "Auto", icon: "⏰", desc: "Light 6am–8pm, dark otherwise" },
];

const COLOR_THEMES = [
  { key: "default", label: "Default", color: "#1C2B3A" },
  { key: "ocean", label: "Ocean", color: "#0369A1" },
  { key: "forest", label: "Forest", color: "#166534" },
  { key: "slate", label: "Slate", color: "#475569" },
  { key: "crimson", label: "Crimson", color: "#991B1B" },
  { key: "violet", label: "Violet", color: "#5B21B6" },
];

export default function SettingsPage() {
  const { themeMode, setThemeMode, colorTheme, setColorTheme } = useApp();

  return (
    <div style={{ maxWidth: "600px" }}>
      <h2 style={{ fontSize: "20px", fontWeight: "600", color: "var(--text-primary)", margin: "0 0 4px 0" }}>Settings</h2>
      <p style={{ fontSize: "14px", color: "var(--text-tertiary)", margin: "0 0 32px 0" }}>Manage your account and preferences.</p>

      {/* Mode */}
      <div style={{ background: "var(--bg-secondary)", border: "1px solid var(--border)", borderRadius: "12px", overflow: "hidden", marginBottom: "16px", boxShadow: "0 1px 4px var(--shadow)" }}>
        <div style={{ padding: "20px 24px", borderBottom: "1px solid var(--border)" }}>
          <div style={{ fontSize: "13px", fontWeight: "600", color: "var(--text-primary)", marginBottom: "4px", textTransform: "uppercase", letterSpacing: "0.05em" }}>Mode</div>
          <div style={{ fontSize: "13px", color: "var(--text-tertiary)" }}>Choose how SyllaPlus looks to you.</div>
        </div>
        <div style={{ padding: "20px 24px" }}>
          <div style={{ display: "flex", gap: "12px" }}>
            {MODES.map(mode => (
              <div key={mode.key} onClick={() => setThemeMode(mode.key)}
                style={{ flex: 1, padding: "16px", borderRadius: "10px", border: `1.5px solid ${themeMode === mode.key ? "var(--blue)" : "var(--border)"}`, background: themeMode === mode.key ? "var(--blue-light)" : "var(--bg)", cursor: "pointer", textAlign: "center", transition: "all 0.15s" }}>
                <div style={{ fontSize: "24px", marginBottom: "8px" }}>{mode.icon}</div>
                <div style={{ fontSize: "14px", fontWeight: "600", color: themeMode === mode.key ? "var(--on-blue-light)" : "var(--text-primary)", marginBottom: "4px" }}>{mode.label}</div>
                <div style={{ fontSize: "12px", color: themeMode === mode.key ? "var(--on-blue-light)" : "var(--text-tertiary)" }}>{mode.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Color Theme */}
      <div style={{ background: "var(--bg-secondary)", border: "1px solid var(--border)", borderRadius: "12px", overflow: "hidden", boxShadow: "0 1px 4px var(--shadow)" }}>
        <div style={{ padding: "20px 24px", borderBottom: "1px solid var(--border)" }}>
          <div style={{ fontSize: "13px", fontWeight: "600", color: "var(--text-primary)", marginBottom: "4px", textTransform: "uppercase", letterSpacing: "0.05em" }}>Color Theme</div>
          <div style={{ fontSize: "13px", color: "var(--text-tertiary)" }}>Pick an accent color for the interface.</div>
        </div>
        <div style={{ padding: "20px 24px" }}>
          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            {COLOR_THEMES.map(theme => (
              <div key={theme.key} onClick={() => setColorTheme(theme.key)}
                style={{ display: "flex", alignItems: "center", gap: "8px", padding: "10px 16px", borderRadius: "10px", border: `1.5px solid ${colorTheme === theme.key ? theme.color : "var(--border)"}`, background: colorTheme === theme.key ? "var(--bg-secondary)" : "var(--bg)", cursor: "pointer", transition: "all 0.15s" }}>
                <div style={{ width: "16px", height: "16px", borderRadius: "50%", background: theme.color, flexShrink: 0 }} />
                <span style={{ fontSize: "13px", fontWeight: colorTheme === theme.key ? "600" : "400", color: "var(--text-primary)" }}>{theme.label}</span>
                {colorTheme === theme.key && <span style={{ fontSize: "12px", color: theme.color }}>✓</span>}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}